import EventLiabilityGrid from './EventLiabilityGrid.vue';

export default EventLiabilityGrid;
